/**
 * @generated SignedSource<<0b92f0dd6780ace7122494e31452ca84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResult = "ALMOST_THERE" | "DEMONSTRATED" | "KEEP_LEARNING" | "NOT_STARTED" | "PASSED" | "PLACED_OUT" | "REVIEW" | "%future added value";
export type StudentsSkillSubStateReportInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  skillIds: ReadonlyArray<string>;
  skillResult: SkillResult;
};
export type DiagnosticsSkillSubStateReportQuery$variables = {
  filter: StudentsSkillSubStateReportInput;
  skip?: boolean | null | undefined;
};
export type DiagnosticsSkillSubStateReportQuery$data = {
  readonly studentsSkillSubStateReport?: ReadonlyArray<{
    readonly skill: {
      readonly id: string;
    };
    readonly usersBySkillResults: ReadonlyArray<{
      readonly key: SkillResult;
      readonly value: ReadonlyArray<{
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
      }>;
    }>;
  }>;
};
export type DiagnosticsSkillSubStateReportQuery = {
  response: DiagnosticsSkillSubStateReportQuery$data;
  variables: DiagnosticsSkillSubStateReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "SkillProgress",
        "kind": "LinkedField",
        "name": "studentsSkillSubStateReport",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfSkillResultAndIEnumerableOfUser",
            "kind": "LinkedField",
            "name": "usersBySkillResults",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "value",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUserId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticsSkillSubStateReportQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticsSkillSubStateReportQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "25b0bfcb72b3e6787c56f9b64cc66125",
    "id": null,
    "metadata": {},
    "name": "DiagnosticsSkillSubStateReportQuery",
    "operationKind": "query",
    "text": "query DiagnosticsSkillSubStateReportQuery(\n  $filter: StudentsSkillSubStateReportInput!\n  $skip: Boolean = false\n) {\n  studentsSkillSubStateReport(filter: $filter) @skip(if: $skip) {\n    skill {\n      id\n    }\n    usersBySkillResults {\n      value {\n        id\n        firstName\n        lastName\n        publicUserId\n      }\n      key\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da9a7664e7204ca77b90d02cf1cdb774";

export default node;
